import React from 'react';
import { map } from 'lodash/fp';
import PropTypes from 'prop-types';
import { CSVLink } from 'react-csv';
import { Icon } from 'rsuite';

function ClientExportCsvButton({ filename, headerData, columns, data }) {
  const filters = [
    ['Filters: '],
    ...map(({ label, value }) => ['', `${label}:`, value], headerData),
    ['']
  ];

  return (
    <CSVLink
      target="_blank"
      className="rs-btn rs-btn-ghost"
      filename={`${filename}.csv`}
      data={[...filters, columns, ...data]}
    >
      <Icon icon="export" /> Export
    </CSVLink>
  );
}

const HeaderDataItemType = PropTypes.shape({
  label: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.array
  ])
});

ClientExportCsvButton.propTypes = {
  filename: PropTypes.string.isRequired,
  headerData: PropTypes.arrayOf(HeaderDataItemType).isRequired,
  columns: PropTypes.arrayOf(PropTypes.string).isRequired,
  data: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.shape({}))).isRequired
};

export default ClientExportCsvButton;
